import './vehicle-step.scss';
import { useOSBContentFragment } from '../../../../hooks/owners-osb/aem-content-util/use-osb-content-fragment';
import FordAccountInfo from './ford-account-info/ford-account-info';
import VehicleSearchForm from './vehicle-search-form/vehicle-search-form';
import VehicleList from './vehicle-list/vehicle-list';
import BookingLookupSection from '../booking-lookup-section/booking-lookup-section';
import { useOSBStep } from '../../../../hooks/owners-osb';

export const OsbLandingPage = () => {
    const osbContentData = useOSBContentFragment(
        'common/osb-v3',
        'vehicle-step'
    );
    const isLoading = !osbContentData;
    const { osbStep } = useOSBStep();
    return (
        <div
            className="osb-v3-vehicle-step-component"
            data-testid="vehicle-step-component-section"
        >
            {!osbStep.isAuthenticatedFlow ? (
                <>
                    <div className="osb-v3-title" data-testid="osb-v3-title">
                        {isLoading ? (
                            <div
                                className="skeleton skeleton-title"
                                style={{
                                    height: '40px',
                                    margin: '0 auto',
                                    width: '60%',
                                }}
                            ></div>
                        ) : (
                            osbContentData.onlineBookingServiceTitleLabel
                        )}
                    </div>
                    <div className="osb-v3-vehicle-step-component-section">
                        <FordAccountInfo />

                        <div className="separator" data-testid="separator">
                            <span>{osbContentData?.orLabel}</span>
                        </div>
                        <VehicleSearchForm />
                    </div>
                </>
            ) : (
                <VehicleList />
            )}
            <BookingLookupSection className="booking-lookup-offset--visual" />
        </div>
    );
};

export default OsbLandingPage;
